import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import Restricted from "src/app/Restricted";
import PATHS, { url } from "src/consts/urlPaths";
import { ALLOWED_ROLES } from "src/services/auth";

type DesignsLinkProps = {
  children?: ReactNode;
  item: { name?: string };
  className?: string;
};

const DesignsLink = ({ children, item, className }: DesignsLinkProps) => (
  <Restricted allowedRoles={ALLOWED_ROLES.DESIGNS}>
    <Link
      id="designs-nav-link"
      to={url(PATHS.DESIGNS)}
      aria-label={item.name}
      className={className}
    >
      {children}
    </Link>
  </Restricted>
);

export default DesignsLink;
